/* Presentation only. Nothing here decides anything: no scoring, no lifecycle
   predicates, no anchor rules. If you want one, it belongs in @acrostic/model.
 *
 * daysSince is NOT reimplemented here. The model's version anchors both ends to a
 * day, and the two previous copies of this file each grew their own that compared
 * noon against Date.now(), so a label changed at lunchtime with nothing having
 * happened. One implementation, imported. */
import { daysSince } from '@acrostic/model';
import { gymToday } from './today.js';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const fmt = {
  /** A stored date, read back the way a person says it. An absent date is a dash. */
  date(d: string | null | undefined): string {
    if (!d) return '—';
    const s = String(d).slice(0, 10);
    const [y, m, day] = s.split('-').map(Number);
    if (!y || !m || !day) return '—';
    const base = `${MONTHS[m - 1]} ${day}`;
    /* A date in another calendar year carries its year. Without it a join date two
       years old prints "Oct 11" and reads as five weeks ago, which on a record is a
       wrong fact rather than a formatting nicety. */
    return y === Number(gymToday().slice(0, 4)) ? base : `${base} ${y}`;
  },

  ago(d: string | null | undefined): string {
    const n = daysSince(d ?? null, gymToday());
    if (n == null) return 'never';
    if (n < 0) return fmt.date(d);
    if (n === 0) return 'today';
    if (n === 1) return 'yesterday';
    if (n < 7) return `${n} days ago`;
    if (n < 14) return 'last week';
    if (n < 60) return `${Math.round(n / 7)} weeks ago`;
    return `${Math.round(n / 30)} months ago`;
  },

  days(d: string | null | undefined): string {
    const n = daysSince(d ?? null, gymToday());
    return n == null ? '—' : `${n}d`;
  },

  num(n: number): string { return n.toLocaleString('en-US'); },

  /** Cents are what the schema stores; dollars are what a gym says. */
  money(cents: number | null | undefined): string {
    return cents == null ? 'Not set' : '$' + Math.round(cents / 100).toLocaleString('en-US');
  },

  initials(name: string | null | undefined): string {
    const parts = String(name ?? '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    const first = parts[0] ?? '';
    const last = parts.length > 1 ? parts[parts.length - 1] ?? '' : '';
    return ((first[0] ?? '') + (last[0] ?? '')).toUpperCase();
  },
};
